import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import userReducer from './Slices/userSlice'
import gameReducer from './Slices/gameSlice'
import popupReducer from './Slices/popupSlice'
import overlayReducer from './Slices/overlaySlice'


export const store = configureStore({
  reducer: {
    user: userReducer,
    game: gameReducer,
    popup: popupReducer,
    overlay: overlayReducer

  },
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false
    }),
  ],
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch